module.exports = __webpack_public_path__ + "img/take_away_small.ffe6d98b.svg";